import { render } from "./bigeye.vue?vue&type=template&id=1d869254&ts=true"
import script from "./bigeye.vue?vue&type=script&lang=ts"
export * from "./bigeye.vue?vue&type=script&lang=ts"

import "./bigeye.vue?vue&type=style&index=0&id=1d869254&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__